import React from 'react';

import {VersionsMenuButton} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/MenuButton/BaseVersionsMenuButton';
import {usePolicyVersions} from 'app/policies/api';

import type {LeftSidebarMenuButton} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {WithRouterProps} from 'react-router';
import type {DetailPolicySerializedType} from 'sweet-types';

export function PolicyVersionsMenuButton({
  object,
  forceTooltipShow,
  hideTooltip,
  location,
  params,
  active,
}: LeftSidebarMenuButton<DetailPolicySerializedType> &
  Pick<WithRouterProps, 'location' | 'params'>) {
  const {data: versions} = usePolicyVersions({objectId: object.id});

  if (versions == null) {
    return null;
  }

  return (
    <VersionsMenuButton
      object={object}
      forceTooltipShow={forceTooltipShow}
      hideTooltip={hideTooltip}
      versions={versions.results}
      params={params}
      location={location}
      active={active}
    />
  );
}
